const reYoutubeVideoId = /^[^"&?/\s]{11}$/; // Ref: https://stackoverflow.com/questions/6903823/regex-for-youtube-id
const extractYoutubeVideoIdCandidate = (url) => {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    const paths = urlObj.pathname.split('/').filter((segment) => segment !== '');
    if (hostname === 'www.youtube.com') {
        if (paths[0] === 'watch') {
            const params = new URLSearchParams(urlObj.search);
            const vParam = params.get('v');
            if (vParam) {
                return vParam;
            }
            const secondPathSegment = paths[1];
            if (secondPathSegment) {
                return secondPathSegment;
            }
        }
        else if (paths[0] === 'embed') {
            return paths[1];
        }
    }
    else if (hostname === 'youtu.be') {
        return paths[0];
    }
    return undefined;
};
export const extractYoutubeVideoId = (url) => {
    const candidate = extractYoutubeVideoIdCandidate(url);
    if (candidate && candidate.match(reYoutubeVideoId)) {
        return candidate;
    }
    return undefined;
};
//# sourceMappingURL=youtube.js.map